import React from 'react';
import { Box, Button, Typography } from '@mui/material';
const RELOAD_FLAG = 'chunk_reload_attempted';
class ChunkErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.handleReload = () => {
            sessionStorage.removeItem(RELOAD_FLAG);
            window.location.reload();
        };
        this.state = { hasError: false, isChunkError: false };
    }
    static getDerivedStateFromError(error) {
        var _a, _b;
        const isChunkError = error.name === 'ChunkLoadError' ||
            ((_a = error.message) === null || _a === void 0 ? void 0 : _a.includes('Loading chunk')) ||
            ((_b = error.message) === null || _b === void 0 ? void 0 : _b.includes('Unexpected token'));
        return { hasError: true, isChunkError };
    }
    componentDidCatch(error) {
        var _a, _b;
        const isChunkError = error.name === 'ChunkLoadError' ||
            ((_a = error.message) === null || _a === void 0 ? void 0 : _a.includes('Loading chunk')) ||
            ((_b = error.message) === null || _b === void 0 ? void 0 : _b.includes('Unexpected token'));
        if (isChunkError && !sessionStorage.getItem(RELOAD_FLAG)) {
            sessionStorage.setItem(RELOAD_FLAG, '1');
            window.location.reload();
        }
    }
    render() {
        if (this.state.hasError) {
            return (React.createElement(Box, { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "60vh", gap: 2 },
                React.createElement(Typography, { variant: "h6", color: "text.secondary" }, "This page failed to load."),
                React.createElement(Typography, { variant: "body2", color: "text.secondary" }, "This is usually caused by a network issue or a recent deployment. Reloading will fix it."),
                React.createElement(Button, { variant: "contained", onClick: this.handleReload }, "Reload Page")));
        }
        return this.props.children;
    }
}
export default ChunkErrorBoundary;
